import ActionDTO from '../../DTO/ActionDTO'
import { NOTIFICATIONS_ADD_ITEM, NOTIFICATIONS_DELETE_ITEM, NOTIFICATIONS_UPDATE_ITEM } from '../ActionTypes'

export const notificationsAddItem = notification => new ActionDTO(NOTIFICATIONS_ADD_ITEM, notification).valueOf
export const notificationsUpdateItem = notification => new ActionDTO(NOTIFICATIONS_UPDATE_ITEM, notification).valueOf
export const notificationsDeleteItem = notification => new ActionDTO(NOTIFICATIONS_DELETE_ITEM, notification).valueOf
